const media = {
  sizes: {
    xxs: 375,
    xs: 520,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1440,
    xxl: 1920,
    xxxl: 2550,
    navigation: 1024,
    wrapper: 1200,
  },
  change(media, match, unmatch) {
    if (media.matches) {
      match();
    } else {
      unmatch();
    }
  },
  is(q, range = "min", match = () => {}, unmatch = () => {}) {
    const size = q.trim();

    if (Object.prototype.hasOwnProperty.call(this.sizes, size)) {
      const query =
        range === "min"
          ? `only screen and (min-width: ${this.sizes[size]}px)`
          : `only screen and (max-width: ${this.sizes[size] - 1}px)`;
      const media = window.matchMedia(query);

      this.change(media, match, unmatch);

      media.addEventListener("change", () => {
        this.change(media, match, unmatch);
      });

      return media.matches;
    }

    throw new ReferenceError(
      `The size ${size} is not a valid breakpoint in: ${JSON.stringify(
        this.sizes
      )}`
    );
  },
};

export { media }
